// extracted by mini-css-extract-plugin
module.exports = {"hero_center":"HeroSlider_hero_center__2nrTZ","hero-center":"HeroSlider_hero-center__21bGb","col_1":"HeroSlider_col_1__18Mov","col_2":"HeroSlider_col_2__28euE"};